export default "__VITE_ASSET__Cyk_KyYC__"